import { Modal } from "react-bootstrap";

const ImageModal = ({
  show,
  onHide,
  isHeader = true,
  title,
  footer,
  size = "lg",
  children,
  className,
  ...otherProps
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size={size}
      centered
      className={`rtl ${className}`}
      {...otherProps}
    >
      {isHeader && (
        <Modal.Header className="d-flex justify-content-between align-items-center">
          {title && (
            <Modal.Title className="fa-1_1x fw-bold text-dark">
              {title}
            </Modal.Title>
          )}
          <i
            className="la la-times cursor-pointer fa-1_2x text-muted"
            onClick={onHide}
          />
        </Modal.Header>
      )}
      <>{children}</>
      {footer && <Modal.Footer>{footer}</Modal.Footer>}
    </Modal>
  );
};

export default ImageModal;
